import React, { useState, Fragment } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fade from "@material-ui/core/Fade";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import Firebase from "../../../firebasehelper";
import { VIDEO_UPLOAD } from "../../../Constants/types";
import { UPLOADING_VIDEO } from "../../../Constants/string";
const AddVideoModal = ({ onCreate }) => {
  const [title, setTitle] = useState("");
  const [video_url, setVideoUrl] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading_script, setLoadingScript] = useState("");
  const handleChangeTitle = ({ target }) => {
    setTitle(target.value);
  };
  const handleChangeDescription = ({ target }) => {
    setDescription(target.value);
  };
  const uploadContent = async (mediaContent) => {
    const uploadFolder = "advent_planner/";
    const uploadTask = Firebase.uploadVideo(
      mediaContent,
      uploadFolder + "/videos"
    );
    setLoading(true);
    setLoadingScript(UPLOADING_VIDEO);
    uploadTask.on(
      "state_changed",
      handleUploadProgress,
      handleUploadError,
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          setLoading(false);
          setLoadingScript("");
          setVideoUrl(downloadURL);
        });
      }
    );
  };
  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + progress + "%";
    setLoadingScript(loading_script);
  };

  const handleUploadError = (error) => {
    setLoadingScript("");
    setLoading(false);
  };
  return (
    <div
      className="modal fade"
      id="add_daily_video_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add a daily video</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <p className="add-event-title">Video title</p>
            <input
              className="form-control form-control-md mb-2"
              onChange={handleChangeTitle}
              value={title}
            />
            <VideoUpload onChangeContent={uploadContent} />
            <Fade
              in={loading}
              style={{
                transitionDelay: loading ? "800ms" : "0ms",
              }}
              unmountOnExit
            >
              <Fragment>
                <p>{loading_script}</p>
                <CircularProgress />
              </Fragment>
            </Fade>
            <p className="add-event-title">Description</p>
            <textarea
              maxLength="280"
              className="form-control form-control-md"
              onChange={handleChangeDescription}
              value={description}
            />
            <p className="bottom-small-text">Max characters: 280</p>

            <div className="modal-footer">
              <button
                className="btn btn-green"
                onClick={() =>
                  onCreate({
                    title,
                    media_url: video_url,
                    media_type: VIDEO_UPLOAD,
                    description,
                  })
                }
                disabled={!video_url}
                data-dismiss="modal"
              >
                Create
              </button>
              <button className="btn btn-orange" data-dismiss="modal">
                Later
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddVideoModal;



// WEBPACK FOOTER //
// ./src/screens/AdventPlanner/components/AddVideoModal.js